import styled from 'styled-components';

export const PayeesContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
`;
